module.exports = __WEBPACK_EXTERNAL_MODULE_427__;


//////////////////
// WEBPACK FOOTER
// external "weaCowork"
// module id = 427
// module chunks = 1